<template>
  <div  style="width: 100%; margin: 0px; margin-top: 2px; font-size: 11px;" class="small-text" >
    <v-card>
      <table >
        <thead style="font-weight: 500">
          <td style="width: 30%; padding-right: 6px; border-right: solid 1px black;">Zone<br>Bookings</td>
          <td style="width: 15%; padding-right: 6px; border-right: solid 1px black;">Asap</td>
          <td style="width: 15%; padding-right: 6px; border-right: solid 1px black;">15</td>
          <td style="width: 15%; padding-right: 6px; border-right: solid 1px black;">30</td>
          <td>1H</td>
        </thead>
        <tr>
          <td style="padding-right: 6px; border-right: solid 1px black;">{{bookingForm.booking.zone != null ? bookingForm.booking.zone.name : ''}}</td>
          <td style="padding-right: 6px; border-right: solid 1px black;">{{asapBookings()}}</td>
          <td style="padding-right: 6px; border-right: solid 1px black;">{{bookingsInXMinutes(0, 15)}}</td>
          <td style="padding-right: 6px; border-right: solid 1px black;">{{bookingsInXMinutes(15, 30)}}</td>
          <td>{{bookingsInXMinutes(30,60)}}</td>
        </tr>
      </table>
    </v-card>
  </div>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";
import moment from "moment";

export default {
  name: "booking_zone_summary",
  components: {
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    zones: Array,
    bookingForm: Object
  },
  computed: {
    
  },
  data() {
    return {
    };
  },
  methods: {
    upcomingBookings: function() {
      var bf = this.bookingForm;

      return this.bookings.filter(function(b) {

        if (bf.booking.zone == null ) {
          return false;
        }

        return b.state == 'booked' && b.zone.id == bf.booking.zone.id;
      });
    },
    asapBookings: function() {
      return this.upcomingBookings().filter(function(b) {
        return b.asap == true;
      }).length;
    },
    bookingsInXMinutes: function(minMinutes, maxMinutes) {

      console.log(this.upcomingBookings());

      return this.upcomingBookings().filter(function(b) {

        var time = moment(b.pickup_timestamp);

        var duration = -moment().diff(time, 'minutes');

        return (duration >= minMinutes && duration < maxMinutes);
      }).length
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

table { border-collapse: collapse; }
tr { border: none; }

ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  // color: green;
  font-weight: 800;
}

.small-text {
  font-size: 13px;
}
</style>
